import react, {useContext} from 'react';
import { viewImgContext } from "..";

const AiBox = ({className}) => {
  const { annoHistory, handleClickAnno } = useContext(viewImgContext);

  return (
    <div className={`h-full flex-col bg-white flex flex-wrap flex-shrink-0 relative w-72 z-20 p-3 ${className}`}>
      <h3 className="w-full h-8 text-sm not-italic text-sm font-medium">Ai History</h3>
      <div className='flex-1 w-full relative border rounded-md p-3' key="whatever">
        {
          annoHistory && annoHistory.length ? annoHistory.map((item, index) => (
            <div className="w-full flex" key={item.id} onClick={() => handleClickAnno(item.id)}>
              <div className='text-sm not-italic cursor-pointer'>{item.body?.length > 0 && item.body[0].value}</div>
            </div>
          )): <div style={{"transform": "translate(-50%, -50%)"}} className='w-full absolute top-2/4 left-2/4 rounded text-xs not-italic p-3 text-gray-300 text-center'>暂无标注记录</div>
        }
      </div>
    </div>
  )
};

export default AiBox;